module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp5-a21e5a8225b5faf4aef4bfa0d3da718d.jpg";